import { FC, ReactNode } from "react";

import { useLibraryItemTypeCopy } from "@src/features/contentLibrary/ContentAvatar";
import { LibraryItemType } from "@src/types.generated";

type Props = {
  title: ReactNode;
  libraryItemType?: LibraryItemType;
  status?: ReactNode;
};

const LibraryItemBuilderTitleExtra: FC<Props> = ({
  title,
  libraryItemType,
  status,
}) => {
  const libraryItemTypeCopy = useLibraryItemTypeCopy();
  const contentTypeLabel = libraryItemType
    ? libraryItemTypeCopy[libraryItemType]
    : undefined;

  return (
    <div className="flex min-w-0 flex-col gap-0.5">
      {title}
      {contentTypeLabel || status ? (
        <div className="flex min-w-0 items-center gap-1.5 px-1.5">
          {contentTypeLabel ? (
            <span className="text-xs font-medium text-gray-8">
              {contentTypeLabel}
            </span>
          ) : null}
          {status}
        </div>
      ) : null}
    </div>
  );
};

export default LibraryItemBuilderTitleExtra;
